/**
 * Cloud GM AI Control Hub — shared constants (logos, provider metadata, icons).
 * Kept as pure data so any child component can import without side effects.
 */
import {
  Brain, TrendingUp, Activity, Globe2, ScanText, FileText, Scale, Building2, IdCard,
} from 'lucide-react';

export const LOGO_URL = {
  Anthropic: '/brand/ast-logo-claude.png',
  Google:    '/brand/ast-logo-gemini.png',
};

export const ICONS = {
  trading_ai_confirmation: TrendingUp,
  trading_news_sentiment: Activity,
  trading_ai_log_stories: Activity,
  auto_translation: Globe2,
  document_ocr: ScanText,
  company_docs_analysis: FileText,
  legal_ai_assistant: Scale,
  rakez_company_setup: Building2,
  admin_rag_chat: Brain,
  visa_id_assistant: IdCard,
};

export const PLATFORM_STYLE = {
  'ASB606':           { bg: 'bg-purple-500/15', text: 'text-purple-300', border: 'border-purple-500/40' },
  'CloudGM Business': { bg: 'bg-orange-500/15', text: 'text-orange-300', border: 'border-orange-500/40' },
  'CloudGM':          { bg: 'bg-cyan-500/15',   text: 'text-cyan-300',   border: 'border-cyan-500/40'   },
  'All':              { bg: 'bg-white/10',      text: 'text-white/80',   border: 'border-white/20'      },
};

export const PROVIDER_META = {
  Anthropic: { bg: '#d97706', gradient: 'from-orange-500/20 to-amber-600/10' },
  Google:    { bg: '#3b82f6', gradient: 'from-blue-500/20 to-cyan-600/10' },
};

export const fmtTs = (s) => {
  if (!s) return '—';
  try {
    return new Date(s).toLocaleString('sv-SE', { hour12: false }).replace('T', ' ').slice(0, 19);
  } catch {
    return s;
  }
};
